
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServicesGrid from './components/ServicesGrid';
import ServiceProcess from './components/ServiceProcess';
import ServiceCTA from './components/ServiceCTA';

export default function Services() {
  useEffect(() => {
    // SEO Meta Tags
    document.title = 'Services Sécurité - Cobra Sécurité | Installation Maintenance Tunisie';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Services complets de sécurité par Cobra Sécurité : installation, maintenance, dépannage 24/7. Vidéosurveillance, alarmes, contrôle d\'accès en Tunisie. Devis gratuit.');
    }
    
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/services`);
    }

    // Schema.org JSON-LD
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Services de Sécurité Cobra",
      "description": "Services complets de sécurité : installation, maintenance et support technique",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/services`,
      "provider": {
        "@type": "Organization",
        "name": "Cobra Sécurité",
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "TN"
        }
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Catalogue de Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Installation de Systèmes",
              "description": "Installation professionnelle de systèmes de sécurité"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Maintenance Préventive",
              "description": "Maintenance régulière et préventive des équipements"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Support Technique 24/7",
              "description": "Assistance technique disponible 24h/24 et 7j/7"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Audit de Sécurité",
              "description": "Évaluation complète des besoins en sécurité"
            }
          }
        ]
      },
      "areaServed": {
        "@type": "Country",
        "name": "Tunisie"
      }
    });
    
    document.head.appendChild(schemaScript);

    return () => {
      document.head.removeChild(schemaScript);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <h1 style={{ position: 'absolute', left: '-9999px' }}>Services de Sécurité Professionnels</h1>
        <ServicesHero />
        <ServicesGrid />
        <ServiceProcess />
        <ServiceCTA />
      </main>
      <Footer />
    </div>
  );
}
